<template>
  <div class="heading-text-image">
    <div class="top-text">
      <h2>{{content.heading}}</h2>
      <div class="text" v-html="content.text"></div>
    </div>
    <div class="image">
      <img
        :src="content.image.sizes.large"
        :alt="content.image.name"
        v-if="content.image"
        :data-pin-url="url"
        :data-pin-media="content.image.url"
        :data-pin-description="content.image.description"
        v-on:click="imageClick(content.image.sizes.large, content.image.caption)"
      />
      <div
        class="post-image-caption"
        v-if="content.image && content.image.caption"
        v-html="content.image.caption"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "heading_text_image",
  props: {
    content: Object,
    imageClick: Function,
    url: String
  }
  
};
</script>

<style lang="scss">
.heading-text-image {
  text-align: right;
  .top-text {
    display: inline-block;
    padding: 100px;
    max-width: calc(65% + 100px);
    text-align: left;
    .text {
      position: relative;
      z-index: 1;
      p::first-letter {
        @include oswald;
        font-size: 94px;
        line-height: 140px;
        margin: -0.3em 0.2em -0.2em 0;
        float: left;
      }
      p:last-child{
        margin-bottom: 0!important;
      }
    }
  }
  .image {
    position: relative;
    z-index: 2;
    img {
      display: block;
      width: 100%;
      cursor: pointer;
    }
  }
}
@media (max-width: $desktop) {
  .heading-text-image {
    text-align: center;
  }
}
@media (max-width: $tablet) {
  .heading-text-image {
    .top-text {
      padding: 100px 50px;
      max-width: calc(65% + 50px);
    }
  }
}
@media (max-width: $mobile) {
  .heading-text-image {
    .top-text {
      max-width: 90%;
      padding: 50px 0;
    }
  }
}
</style>